import {
	FETCH_DEDUCTIONS_SUCCESS,
	FETCH_DEDUCTION_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_DEDUCTIONS_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_DEDUCTION_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
